import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import {Layout, Image, Typography} from 'antd'
import axios from 'axios';
import './Detail.css'

const Content = Layout
const {Title, Text} = Typography

const MOVIE_API = "https://backendexample.sanbersy.com/api/data-movie"
const GAME_API = "https://backendexample.sanbersy.com/api/data-game"

const Detail = () => {
  let {id, type} = useParams()
  const [item, setItem] = useState("")
  const [trigger, setTrigger] = useState(true)

  useEffect(() => {
    if (item === "") {
      const getDetail = async () => {
        if (type === 'movie') {
          const result = await axios.get(MOVIE_API + "/" + id)
          setItem(result.data)
          
        } else {
          const result = await axios.get(GAME_API + "/" + id)
          setItem(result.data)
          // setTrigger(false)
        }
      }
      getDetail()
      setTrigger(false)
    }
  }, [trigger])
  
  return (
    <Content className="site-layout" style={{ padding: '0 50px', marginTop: 64 }}>
      <div className="site-layout-background" style={{ padding: 24, minHeight: 380 }}>
        <div id="detail">
          <Image
          src={item.image_url}
          preview={false}
          />
          <div className="desc">
            <Title level={2}>
              <h2>{item.title ? item.title : item.name}</h2>
            </Title>
            {
              (type === "movie") ?
              <ul>
                <li>Released Year: <b>{item.year}</b></li>
                <li>Duration: <b>{item.duration} min</b> </li>
                <li>Genre: <b>{item.genre}</b></li>
                <li>Rating: <b>{item.rating}/10</b></li>
                <li>Review: <b>{item.review}</b></li>
                <li className="description" >
                <Text>Description: <br /> <em>{item.description}</em></Text>
                </li>
              </ul>
              : <ul>
                  <li>Released Year: <b>{item.release}</b></li>
                  <li>Platform: <b>{item.platform}</b> </li>
                  <li>Single Player: <b>{item.singlePlayer ? "Yes" : "No"}</b></li>
                  <li>Multi Player: <b>{item.multiplayer ? item.multiplayer : "No" }</b></li>
                  <li>Genre: <b>{item.genre}</b></li>
                </ul>
            }
            
            
          </div>
        </div>
      </div>
    </Content>
  )
}

export default Detail